import DataTable from '../../components/DataTable';

import { itemTypes, itemGroups } from '@/constants';

export default function PlayerSchedule({ event }) {
  const options = [
    { value: 'playerName', label: '选手姓名', type: 'text' },
    { value: 'playerId', label: '选手编号', type: 'text' },
    {
      value: 'itemId',
      label: '比赛项目',
      type: 'select',
      options: itemTypes.map((item, index) => ({
        label: item,
        value: index + 1,
      })),
    },
    {
      value: 'groupId',
      label: '比赛组别',
      type: 'select',
      options: itemGroups.map((item, index) => ({
        label: item,
        value: index + 1,
      })),
    },
    // { value: 'time', label: '比赛时间', type: 'time' },
  ];
  const columns = [
    { title: '选手姓名', dataIndex: 'playerName', key: 'playerName' },
    { title: '选手编号', dataIndex: 'playerId', key: 'playerId' },
    { title: '项目', dataIndex: 'itemName', key: 'itemName' },
    { title: '组别', dataIndex: 'groupName', key: 'groupName' },
    { title: '场地名称', dataIndex: 'place', key: 'place' },
    { title: '开始时间', dataIndex: 'matchStartTime', key: 'matchStartTime' },
    { title: '结束时间', dataIndex: 'matchEndTime', key: 'matchEndTime' },
    // { title: '比赛顺序', dataIndex: 'sort', key: 'sort' },
  ];

  return (
    <DataTable
      options={options}
      onDownload={() => {}}
      columns={columns}
      api={`/events/player/schedule/list/${event.id}`}
    />
  );
}
